import { useCallback, useEffect, useState } from 'react';
import { fromInput } from 'src/functions/fromInput';
import { fromModifierKey } from 'src/functions/fromModifierKey';

const useKeyPress = (targetKey: string | string[], callback?: () => void, isDisabled?: boolean): boolean => {
	const [keyPressed, setKeyPressed] = useState(false);

	const downHandler = useCallback(
		(event: KeyboardEvent) => {
			const { key } = event;

			if (
				!fromInput(event) &&
				!fromModifierKey(event) &&
				((typeof key === 'string' && key === targetKey) || (Array.isArray(targetKey) && targetKey.includes(key)))
			) {
				setKeyPressed(true);
				if (callback) callback();
			}
		},
		[targetKey, callback]
	);

	const upHandler = useCallback(
		(event: KeyboardEvent) => {
			const { key } = event;

			if (
				!fromInput(event) &&
				!fromModifierKey(event) &&
				((typeof key === 'string' && key === targetKey) || (Array.isArray(targetKey) && targetKey.includes(key)))
			) {
				setKeyPressed(false);
			}
		},
		[targetKey]
	);

	useEffect(() => {
		if (isDisabled) return;

		window.addEventListener('keydown', downHandler);
		window.addEventListener('keyup', upHandler);

		return () => {
			window.removeEventListener('keydown', downHandler);
			window.removeEventListener('keyup', upHandler);
		};
	}, [downHandler, upHandler, isDisabled]);

	return keyPressed;
};

export { useKeyPress };
